import { render, staticRenderFns } from "./PushNotificationTemplate.vue?vue&type=template&id=11b3f9c0&"
import script from "./PushNotificationTemplate.vue?vue&type=script&lang=js&"
export * from "./PushNotificationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports